import classNames from 'classnames'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import Navigation from './Navigation'

import Text from 'admin/components/common/Text'
import {
  withContext,
  WithContextProps,
} from 'admin/components/common/withContext'
import { State } from 'admin/redux/ducks'
import {
  LoginState,
  selectCurrentOrgAccountAction,
} from 'admin/redux/ducks/login'
import DropdownMenu from 'components/ui/DropdownMenu'
import { ChevronDownIcon, ChevronLeftIcon } from 'components/ui/Icons'
import { LoginOrgAccountType } from 'types'

type HeaderProps = {
  className?: string
  newURL: string
  includesOldDomain: boolean
} & WithContextProps

const Header: React.FC<HeaderProps> = ({ className, config, locale, newURL, includesOldDomain }) => {
  const login = useSelector((state: State) => state.login as LoginState)
  const dispatch = useDispatch()

  const handleFocus = (event: React.FocusEvent<HTMLElement>) => {
    ;(event.currentTarget as HTMLElement).focus()
  }

  const handleOrgAccountClick = (
    event: React.SyntheticEvent<any>,
    orgAccountId: string
  ) => {
    event.preventDefault()
    ;((event.target as Node).ownerDocument.activeElement as HTMLElement).blur()
    dispatch(selectCurrentOrgAccountAction(orgAccountId))
  }

  let orgAccounts: LoginOrgAccountType[] = []
  if (login && login.data && login.data.isLoggedIn) {
    const organization =
      login.data.organizations &&
      login.data.organizations.find(
        (org) => org.orgNumber === login.data.orgNumber
      )
    if (organization) {
      orgAccounts = organization.orgAccounts
    }
  }

  return (
    <div className={classNames('Header', className)}>
      <div className="l-container l-columns l-columns--align-middle l-flex--all-sizes l-height--100%">
        {login && login.data && login.data.isLoggedIn && (
          <Navigation
            className="l-flex"
            handleFocus={handleFocus}
            config={config}
            locale={locale}
          />
        )}
        {login && login.data && login.data.isLoggedIn && (
          <div className="Header__login l-flex l-flex--fixed l-align--right u-whitespace--nowrap">
            <DropdownMenu
              openOnClick
              openOnFocus={false}
              position="right"
              buttonContent={
                <>
                  <span>
                    <span>{login.data.name}</span>
                    <span>{login.data.orgAccountName}</span>
                  </span>
                  <ChevronDownIcon />
                </>
              }
              classname="Header__DropdownMenu"
              buttonClassname="Header__DropdownMenu__button"
              containerClassname="Header__DropdownMenu__container"
            >
              <ul>
                {orgAccounts.length > 1 && (
                  <>
                    <li className="DropdownMenuItem--inactive">
                      <strong>{login.data.orgName}</strong>
                    </li>
                    {orgAccounts.map((orgAccount) => (
                      <li
                        key={`headerOrgAccount_${orgAccount.orgAccountId}`}
                        onMouseDown={(e) =>
                          handleOrgAccountClick(e, orgAccount.orgAccountId)
                        }
                      >
                        {orgAccount.orgAccountId === login.data.orgAccountId ? (
                          <strong>
                            <ChevronLeftIcon /> {orgAccount.orgAccountName}
                          </strong>
                        ) : (
                          <span className="l-margin--l">
                            {orgAccount.orgAccountName}
                          </span>
                        )}
                      </li>
                    ))}
                  </>
                )}
                <li onMouseDown={(e) => e.preventDefault()}>
                  <Link to="/logga_ut">
                    <Text>general.log_out</Text> {login.data.name}
                  </Link>
                </li>
              </ul>
            </DropdownMenu>
          </div>
        )}
      </div>
      {includesOldDomain && (
        <div className="Header__notification">
          <Text>url.new_admin_url_description</Text>
          <a href={newURL} className="Header__notification__link">fakturatjanst.coop.se/admin</a>
        </div>
      )}
    </div>
  )
}

export default withContext(Header)
